import React, { useState } from 'react';
import './InstrumentDisplayBlock.css';

interface InstrumentGalleryImage {
  src: string;
  alt?: string;
  displayStyle?: string; // "primary" or "secondary"
}

interface InstrumentDisplayBlockProps {
  title: string;
  text: React.ReactNode;
  images: InstrumentGalleryImage[];
}

const InstrumentDisplayBlock: React.FC<InstrumentDisplayBlockProps> = ({ title, text, images }) => {
  const [enlargedImage, setEnlargedImage] = useState<InstrumentGalleryImage | null>(null);

  const primaryImages = images.filter(img => img.displayStyle === 'primary').slice(0, 2);
  const secondaryImages = images.filter(img => img.displayStyle === 'secondary');

  const handleImageClick = (img: InstrumentGalleryImage) => setEnlargedImage(img);
  const handleClose = () => setEnlargedImage(null);

  return (
    <div className="instrument-display-block">
      <h3 className="section-header">{title}</h3>
      <div className="instrument-description">{text}</div>
      <div className="instrument-gallery">
        {secondaryImages.length > 0 && (
          <div className="instrument-gallery-secondary-row">
            {secondaryImages.map((img, idx) => (
              <img
                key={`secondary-${idx}`}
                src={img.src}
                alt={img.alt || `Instrument image ${idx + 1}`}
                className="instrument-gallery-image-secondary"
                onClick={() => handleImageClick(img)}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </div>
        )}
        <div className="instrument-gallery-primary-row">
          {primaryImages.map((img, idx) => (
            <img
              key={`primary-${idx}`}
              src={img.src}
              alt={img.alt || `Instrument image ${idx + 1}`}
              className="instrument-gallery-image-primary"
              onClick={() => handleImageClick(img)}
              style={{ cursor: 'pointer' }}
            />
          ))}
        </div>
      </div>
      {enlargedImage && (
        <div className="lightbox-overlay" onClick={handleClose}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <img
              src={enlargedImage.src}
              alt={enlargedImage.alt || 'Enlarged instrument'}
              className="lightbox-image"
            />
            <button className="lightbox-close" onClick={handleClose}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstrumentDisplayBlock;